<template>
  <div>
    <!-- 검색 -->
    <search-nav>
      <search-year v-model="nav.year" :options="{
        default: new Date().getFullYear(),
      }" @input="onClickSearch"/>
      <search-year-half v-model="nav.half" class="ml-2" label="" :options="{
        default: new Date().getMonth() < 6 ? '상반기' : '하반기',
        type: 'radio',
      }" @input="onClickSearch"/>
    </search-nav>

    <!-- 목록 -->
    <vx-card>
      <div class="flex">
        <vs-select v-model="nav.perPage" @input="onClickSearch" autocomplete>
          <vs-select-item v-for="(item, index) in [50, 75, 100, 125, 150]" :key="index" :value="item" :text="`${item}개씩 보기`" />
        </vs-select>

        <div class="ml-auto">
          <search-keyword label="" v-model="nav.keyword" @input="updateList"/>
        </div>
      </div>

      <div class="flex" style="margin-top: 14px;">
        <p class="my-auto" style="font-size: 18px; font-weight: 500">대상수 : <span style="font-weight: 400">{{ fieldData.length }}개소</span></p>
        <vs-button class="ml-auto" color="secondary" @click="onClickExcelDownload"> <feather-icon icon="DownloadIcon" style="width: 20px; height: 20px" class="align-bottom mr-1" />엑셀 다운로드</vs-button>
      </div>

      <div class="grid border-top border-left" style="margin-top: 14px; grid-template-columns: minmax(100px, 310fr) 468fr minmax(100px, 310fr) 468fr; font-size: 16px; text-align: center;">
        <span class="p-2 border-right border-bottom" style="background-color: #FAFAFA; font-weight: 700;">작성주기</span>
        <span class="p-2 border-right border-bottom">반기 1회</span>
        <span class="p-2 border-right border-bottom" style="background-color: #FAFAFA; font-weight: 700;">작성 / 대상</span>
        <span class="p-2 border-right border-bottom">
          <i v-if="successFields.length === searchedFields.length" class="dot success"/>
          <i v-else class="dot danger" />
          {{ successFields.length }} / {{ searchedFields.length }}
        </span>
      </div>

      <table style="margin-top: 14px;">
        <colgroup>
          <col width="70px"/>
          <col width="495px"/>
          <col width="495px"/>
          <col width="495px"/>
        </colgroup>
        <thead>
        <tr>
          <th>연번</th>
          <th>소관부서</th>
          <th>시설명</th>
          <th>
            <div class="flex items-center justify-center cursor-pointer" @click="onClickSortToggle()">
              작성여부

              <div class="ml-2 flex items-center justify-center " >
                <feather-icon v-if="sort_작성여부 === 0" icon="MinusIcon" style="width: 16px; height: 16px" />
                <feather-icon v-if="sort_작성여부 === 1" icon="ChevronDownIcon" style="width: 16px; height: 16px" />
                <feather-icon v-if="sort_작성여부 === 2" icon="ChevronUpIcon" style="width: 16px; height: 16px" />
              </div>
            </div>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in list" :key="index">
          <td>{{ nav.perPage * (nav.currentPage - 1) + index + 1 }}</td>
          <td>{{ item.소관부서 }}</td>
          <td>{{ item.시설물명 }}</td>
          <td>
            <i v-if="item.작성여부 > 0" class="dot success"/>
            <i v-else class="dot danger"/>
            {{ item.작성여부 > 0 ? 1 : 0 }} / 1
          </td>
        </tr>
        </tbody>
      </table>

      <div class="w-full vs-con-table">
        <div class="con-pagination-table vs-table--pagination">
          <k-pagination
            :total="(nav.lastPage) ? nav.lastPage : 1"
            v-model="nav.currentPage" @change="onChangePage"></k-pagination>
        </div>
      </div>

    </vx-card>

    <popup-excel-download
      v-model="showExcelPopup"
      :list="excelList"
      title="안전관리 의무사항 이행 자체점검 결과 작성 현황"
      :file-name="`${nav.year}년도 ${nav.half}${nav.keyword ? `, ${nav.keyword}`: ''} - 안전관리 의무사항 이행 자체점검 결과 작성 현황`"
    />
  </div>
</template>

<script>
import SearchNav from "@/components/nav/SearchNav.vue";
import SearchYearHalf from "@/views/list/components/SearchYearHalf.vue";
import SearchYear from "@/views/list/components/SearchYear.vue";
import SearchKeyword from "@/views/list/components/SearchKeyword.vue";
import * as DataUtil from "@/util/DataUtil";
import * as UIUtil from "@/util/UiUtil";
import KPagination from "@/components/kPagination/kPagination.vue";
import PopupExcelDownload from "@/popup/PopupExcelDownload";

export default {
  components: {PopupExcelDownload, KPagination, SearchKeyword, SearchYear, SearchYearHalf, SearchNav},
  props: {
    header: Object,
    board: Object,
    value: Object,
  },
  computed: {
    successFields () {
      return this.searchedFields.filter((item) => {
        return item.작성여부;
      });
    },
    searchedFields () {
      if (this.fieldData.length > 0) {
        return this.fieldData.map((data) => {
          const meta = JSON.parse(data.meta);
          const _data = {
            시설물명: data.field_name,
            소관부서: meta.소관부서,
            작성여부: data.작성여부,
          }
          return _data;
        }).filter((item) => {
          if (this.nav.keyword) {
            const keyword = this.nav.keyword.toLowerCase();
            if (item.시설물명.toLowerCase().indexOf(keyword) === -1 && item.소관부서.toLowerCase().indexOf(keyword) === -1) {
              return false;
            }
          }
          return true;
        });
      }
      return []
    }
  },
  watch: {
    postList() {
      // 작성여부를 postList 에서 가져온다.
      const fieldData = JSON.parse(JSON.stringify(this.fieldData));
      fieldData.forEach((item) => {
        const post = this.postList.find((post) => {
          if (post.fields) {
            return post.fields.find((field) => `${field.id}` === `${item.id}`);
          } else {
            return false;
          }
        });
        if (!item.작성여부) item.작성여부 = 0;
        if (post) {
          item.작성여부 += 1; // 작성된 개수와 상관없이 1을 표기하지만, 몇 개 작성됐는지 미리 파악하기 위해 1씩 증가 시킨다.
        } else {
          item.작성여부 = 0;
        }
      });

      this.fieldData = fieldData;
      this.updateList();
    }
  },
  data () {
    return {
      excelList: [],
      showExcelPopup: false,
      nav: {
        perPage: 50,
        currentPage: 1,
        lastPage: 0,
        year: "", // 초기화는 options.default 값으로 설정한다.
        half: "", // 초기화는 options.default 값으로 설정한다.
        keyword: "",
      },
      codes: {
        '도서관': 'library',
        '박물관 및 미술관': 'museum',
        '의료기관': 'medical',
        '어린이집': 'daycare',
        '업무시설': 'office',
        '실내공연장': 'indoor-auditorium',
        '둘이상용도건축물': 'mixed-use-building',
        '건축물': 'building',
        '항만(방파제)': 'port',
        '항만(부두)': 'port-dock',
        '교량': 'bridge',
        '터널': 'tunnel',
        '옹벽': 'retaining-wall',
        '절토사면': 'cutting-slope',
        '제방': 'dike',
        '소규모수도': 'waterworks',
        '청사': 'government-building',
        '복합시설': 'complex-facility',
        '하수도': 'sewage-treatment',
        '상수도': 'water-supply',
        '실내체육시설': 'indoor-sports-facility',

        '급식소': 'mass_feeding_facility',
        '먹는물': 'drinking-water',
        '승강기': 'lift',
        '식품제조가공업': 'food-processing',
        '어린이 놀이시설': 'kids-play-area',
      },
      postList: [], // 1044 목록
      fieldData: [], // 전체 fields
      list: [], // 화면에 보이는 fields
      sort_작성여부: 0, //0: default, 1: desc, 2: asc
    }
  },
  async created () {
    // 전체 fields 와 전제문서(1044) 를 가져와서
    // fields[%].작성여부 변수에 값을 저장한다. (watch 로 처리)
    await this.loadFieldList();
    await this.loadPostList();
  },
  methods: {
    async loadPostList() {
      const postList = await DataUtil.loadDefragmentation(this.$store, "board/LOAD_POST_LIST", {
        projectId: this.$route.params.proj_id,
        boardId: 1044,
        page: 1,
        perPage: 100,
        conditions: [
          { key: 'header.year', operator: '=', value: this.nav.year },
          { key: 'body.구분', operator: '=', value: this.nav.half }
        ],
        withMeta: true,
        metaKeys: [
          'body.fields[%].id',
          'body.fields[%].field_name',
        ],
        onlyMeta: true,
      }, true);

      this.postList = postList.map(item => {
        return item.postContents ? item.postContents.body || {} : {}
      });
    },

    async _loadFieldList(page, list) {
      const codes = Object.values(this.codes);
      const params = {
        page,
        perPage: 50,
        projectId: this.$route.params.proj_id,
        codes,
        showAll: true,
      };
      const _apiData = await this.$store.dispatch("project/LOAD_FIELD_LIST", params);
      list.push(..._apiData.data);
      if (_apiData && Number(_apiData.last_page) >= Number(page)) {
        await this._loadFieldList(page + 1, list);
      }
    },
    async loadFieldList() {
      UIUtil.loading(true)
      const data = [];
      await this._loadFieldList(1, data)
      this.fieldData = data;
      UIUtil.loading(false)

      this.updateList();
    },

    setTableFieldData(fieldData) {
      // 테이블 형식에 맞게 apiData 변형
      const list = fieldData.map((data) => {
        const meta = JSON.parse(data.meta);
        const _data = {
          시설물명: data.field_name,
          소관부서: meta.소관부서,
          작성여부: data.작성여부,
        }
        return _data;
      }).filter((item) => {
        if (this.nav.keyword) {
          const keyword = this.nav.keyword.toLowerCase();
          if (item.시설물명.toLowerCase().indexOf(keyword) === -1 && item.소관부서.toLowerCase().indexOf(keyword) === -1) {
            return false;
          }
        }
        return true;
      }).sort((a, b) => {
        // 작성여부 내림차순
        if (this.sort_작성여부 === 1) {
          if (a.작성여부 > b.작성여부) return -1;
          if (a.작성여부 < b.작성여부) return 1;
        }
        // 작성여부 오름차순
        else if (this.sort_작성여부 === 2) {
          if (a.작성여부 < b.작성여부) return -1;
          if (a.작성여부 > b.작성여부) return 1;
        }

        // 소관부서, 시설명 순으로 오름차순 정렬
        if (a.소관부서 < b.소관부서) return -1;
        if (a.소관부서 > b.소관부서) return 1;
        if (a.시설물명 < b.시설물명) return -1;
        if (a.시설물명 > b.시설물명) return 1;
        return 0;
      });

      const _total = Math.ceil(list.length / this.nav.perPage);
      this.nav.lastPage = _total < 1 ? 1 : _total;

      const perPage = this.nav.perPage;
      const currentPage = this.nav.currentPage;

      const start = (currentPage - 1) * perPage;
      const end = currentPage * perPage;

      return list.slice(start, end);
    },

    updateList() {
      this.list = this.setTableFieldData(this.fieldData);
    },

    onClickSearch () {
      this.loadPostList();
    },
    onClickExcelDownload () {
      this.excelList = this.searchedFields.sort((a, b) => {
        // 작성여부 내림차순
        if (this.sort_작성여부 === 1) {
          if (a.작성여부 > b.작성여부) return -1;
          if (a.작성여부 < b.작성여부) return 1;
        }
        // 작성여부 오름차순
        else if (this.sort_작성여부 === 2) {
          if (a.작성여부 < b.작성여부) return -1;
          if (a.작성여부 > b.작성여부) return 1;
        }

        // 소관부서, 시설명 순으로 오름차순 정렬
        if (a.소관부서 < b.소관부서) return -1;
        if (a.소관부서 > b.소관부서) return 1;
        if (a.시설물명 < b.시설물명) return -1;
        if (a.시설물명 > b.시설물명) return 1;
        return 0;
      });
      this.showExcelPopup = true;
    },
    onChangePage(page) {
      this.nav.currentPage = page;
      this.updateList();
    },
    onClickSortToggle() {
      this.sort_작성여부 = (this.sort_작성여부 + 1) % 3;
      this.updateList();
    },
  }
}
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;

  border-top: solid 1px #cdcdcd;
  border-left: solid 1px #cdcdcd;

  &,
  th,
  td {
    border-right: solid 1px #cdcdcd;
    border-bottom: solid 1px #cdcdcd;
    font-size: 14px;
  }

  th {
    text-align: center;
    padding: 16px 6px;
    background: #FAFAFA;
    font-weight: 500;
  }

  td {
    padding: 6px;
    font-weight: 400;
  }

  tbody {
    tr:hover {
      background-color: #EDEDED;
    }
  }
}
</style>
